<script lang="ts" generics="DataType">
  import type { ChangeEventHandler } from "svelte/elements";

	export let name: string;
	export let group: DataType;
	export let value: DataType;
	export let disabled = false;
	export let onChange: ChangeEventHandler<HTMLInputElement> = (e) => {};
</script>

<label class="radio body-m book m-0">
	<input type="radio" bind:group {...$$props} {name} {value} on:change={onChange} {disabled} />
	<span class="icon-check-empty-20"></span>
	<span class="icon-Selection-radio-on-20"></span>
	<div class="label" class:disabled={disabled}>
		<slot />
	</div>
</label>

<style lang="scss">
	@use 'color';
	input[type=radio] {
		display: none;
		& ~ .icon-Selection-radio-on-20 {
			display: none;
			color: color.$primary-variant;
		}
		&:checked {
			& ~ .icon-check-empty-20 { display: none; }
			& ~ .icon-Selection-radio-on-20 { display: inline-block; }
		}
	}

	span[class^="icon-"] {
		color: color.$on-background-low-importance;
		position: absolute;
		left: 24px;
		margin-top: 2px;
	}
	.label {
    margin-left: 32px;
    &.disabled {
			color: color.$on-background-low-importance;
    }
  }
</style>
